import { isValid, parse } from "date-fns";
import {
    printLabel,
    REPORT_DATA_LABEL_FORMAT_WEEKLY,
} from "@common/helpers/reports";
import { ReportFilters } from "@common/types/filters/reports";
import { fullMonthFullYearFormat, yearOnlyFormat } from "@common/helpers/date";

export function validDateLabel(label: string) {
    return (
        isValid(parse(label, REPORT_DATA_LABEL_FORMAT_WEEKLY, new Date())) ||
        isValid(parse(label, fullMonthFullYearFormat, new Date())) ||
        isValid(parse(label, yearOnlyFormat, new Date()))
    );
}

export function formatColHeaderLabel(
    filters: ReportFilters,
    label?: string,
    fullRange: boolean = false,
) {
    if (label && validDateLabel(label)) {
        return printLabel(label, filters, fullRange);
    }
    return label;
}
